/**
 * Make a value safe to pass to `like` / `ilike` as a LITERAL.
 *
 * DUPLICATED, DELIBERATELY. The canonical twin is
 * `supabase/functions/_shared/sql/escape-like.ts`. They cannot share a module:
 * edge functions run on Deno and import with explicit `.ts` extensions, while
 * this side is bundled by Metro through the `@/` alias, and neither resolver
 * accepts the other's form. Both are covered by grep-guard ARCH-21, and both have
 * a test asserting the same behaviour — including the escape ordering, which is
 * the part that is subtly wrong if rewritten from memory.
 *
 * THE DEFECT IT EXISTS FOR
 *   `ilike` is a pattern match and reads like a case-insensitive `=`. `_` matches
 *   any single character and `%` matches any run. Server-side that leaked one
 *   founder's pitch-deck submission to another, because underscores are ordinary
 *   in email local parts. Client-side the same shape widens a search silently:
 *   a company search for `a_b` quietly returns `axb` too, and a name lookup meant
 *   as equality stops being equality.
 *
 * Where a wildcard IS intended, escape only the user's portion:
 *
 *     .ilike('name', `%${escapeLikePattern(query)}%`)
 */

/**
 * Backslash first. Escaping it last would escape the backslashes this function
 * just inserted to protect `_` and `%`, leaving a literal backslash followed by a
 * live wildcard — the exact hole it is closing.
 */
export function escapeLikePattern(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/%/g, '\\%')
    .replace(/_/g, '\\_');
}
